import React from 'react';
import { Link } from 'react-router-dom';
import { isAppShell } from '../../marketing/utils/isInstalledApp';
import './AuthGate.scss';

export type AuthPanel = {
  eyebrow: string;
  title: React.ReactNode;
  lead?: string;
  points?: string[];
};

type Props = {
  children: React.ReactNode;
  panel?: AuthPanel;
  homeTo?: string;
  wide?: boolean;
  mobileApp?: boolean;
};

const AuthGate: React.FC<Props> = ({ children, panel, homeTo, wide, mobileApp }) => {
  const home = homeTo ?? (isAppShell() ? '/login' : '/');

  return (
    <div
      className={`auth${panel ? ' auth--split' : ''}${wide ? ' auth--wide' : ''}${
        mobileApp ? ' auth--app-mobile' : ''
      }`}
    >
      {panel ? (
        <aside className="auth__panel">
          <Link to={home} className="auth__brand">
            <img src="/favicon.svg" alt="" />
            Zeedcom
          </Link>
          <p className="auth__eyebrow">{panel.eyebrow}</p>
          <h1 className="auth__display">{panel.title}</h1>
          {panel.lead ? <p className="auth__lead">{panel.lead}</p> : null}
          {panel.points ? (
            <ul className="auth__points">
              {panel.points.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          ) : null}
        </aside>
      ) : null}

      <div className="auth__stage">
        <Link
          to={home}
          className={`auth__brand auth__brand--ink${panel ? ' auth__brand--mobile' : ''}`}
        >
          <img src="/favicon.svg" alt="" />
          Zeedcom
        </Link>
        <div className="auth__card">{children}</div>
      </div>
    </div>
  );
};

export default AuthGate;
